import {
  containerCss,
  contentCss,
  deleteButtonCss,
  deleteIconCss,
  filtersCss,
  iconCss,
  keywordsCss,
} from "./index.styles";

import type { SearchFilterSetItem } from "~/client/components/search/hooks/useSavedSearchFilterSets";
import { ListItem } from "~/client/components/search/SearchBoxDropdown/ListItem";
import { ListItemLink } from "~/client/components/search/SearchBoxDropdown/ListItemLink";
import { SearchFilterSetDescription } from "~/client/components/search/SearchFilterSetDescription";
import { buildSearchPathWithParamsBySearchFilterSet } from "~/client/components/search/SearchHistory/buildSearchPathWithParams";
import { KibelaSymbol } from "~/client/components/shared/kibela_symbol";

interface Props {
  item: SearchFilterSetItem;
  query: string;
  isSelected: boolean;
  onDelete: (id: string) => void;
}
export const SavedSearchFilterSet: React.FC<Props> = ({ item, query, isSelected, onDelete }) => {
  return (
    <ListItem isSelected={isSelected}>
      <div css={containerCss}>
        <span css={iconCss}>
          <KibelaSymbol id="search" />
        </span>
        <ListItemLink to={buildSearchPathWithParamsBySearchFilterSet(query, item)}>
          <div css={contentCss}>
            <span data-testid="query" css={keywordsCss}>
              {query}
            </span>
            <div data-testid="filters" css={filtersCss}>
              <SearchFilterSetDescription filterSet={item} />
            </div>
          </div>
        </ListItemLink>
        <button type="button" onClick={() => onDelete(item.id)} css={deleteButtonCss}>
          <KibelaSymbol id="close" css={deleteIconCss} />
        </button>
      </div>
    </ListItem>
  );
};
